import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import BusTripApi from "Services/BusTrip";

const BusTripDeleteModal = ({ openDialog, tripId, handleClose }) => {
  const dispatch = useDispatch();

  const handleDelete = () => {
    if (!tripId) {
      dispatch(
        showSnackbar({
          message: "Trip ID not found",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    BusTripApi.deleteBusTrip(tripId).then(
      () => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: "Bus trip deleted successfully",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "success",
          })
        );
        handleClose(true);
      },
      (err) => {
        dispatch(hideLoader());
        dispatch(
          showSnackbar({
            message: err?.response?.data?.message || "Error while deleting bus trip",
            autoHideDuration: 3000,
            anchorOrigin: { vertical: "top", horizontal: "right" },
            variant: "error",
          })
        );
      }
    );
  };

  return (
    <Dialog open={openDialog} onClose={() => handleClose(false)} fullWidth maxWidth="xs">
      <DialogTitle>{"Are you sure delete this bus trip ?"}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">Trip ID: {tripId || "-"}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleClose(false)}>Disagree</Button>
        <Button onClick={handleDelete} autoFocus>
          Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BusTripDeleteModal;
